import React, { useState, useEffect } from "react";
import * as api from "../../api/user-app-api.js";

export const SplashScreen = () => {
    const [logo, setLogo] = useState(null);
    const [website, setWebsite] = useState(null);
    const [logoLoading, setLogoLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const fetchLogo = async () => {
            try {
                const res = await api.fetchSettings();

                if (isMounted && res?.data?.splash) {
                    setLogo(res.data.splash);
                    setWebsite(res.data.data.website_name);
                }
            } catch (e) {
                console.error("Failed to fetch logo:", e);
            } finally {
                if (isMounted) setLogoLoading(false);
            }
        };

        fetchLogo();

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="text-center">
                <div className="mb-6 flex justify-center p-12">
                    {logoLoading ? (
                        <div className="h-21 w-21 rounded-full border-4 border-[#01a499] border-t-transparent animate-spin" />
                    ) : logo ? (
                        <img
                            src={logo}
                            alt={website || "OzNULI"}
                            className="h-21 object-contain"
                        />
                    ) : (
                        <span className="text-2xl font-bold text-[#01a499]">
                            OzNULI
                        </span>
                    )}
                </div>

                {/* <h2 className="text-2xl font-bold text-[#01a499] mb-2">
                    Recycle Trash
                </h2>
                <h2 className="text-2xl font-bold text-[#01a499] tracking-wide">
                    Earn CASH
                </h2> */}
                <p className="mt-2 text-xs text-gray-500">
                    Powered by Eco Friend Industries
                </p>
            </div>
        </div>
    );
};
